import Component from './csv_download.vue'
export default Component
